import { __ } from "@wordpress/i18n";
import { css } from "@/utils/css";

type Tab = {
    value: string;
    label: string;
    element: React.ReactNode;
};

type Props = {
    tabs: Tab[];
    onTabChange?: (tab: string) => void;
    activeTab?: string;
    standalone?: boolean;
};

export function Tabs({ tabs, onTabChange, activeTab, standalone = false }: Props) {
    const tabContent = tabs.find((tab) => tab.value === activeTab)?.element;

    return (
        <div className={css(!standalone ? "panel" : "")}>
            <div className={css("tabs")}>
                {tabs.map((tab) => {
                    return (
                        <button
                            key={tab.value}
                            className={css(`tab-button`, activeTab === tab.value ? "active" : "")}
                            onClick={() => onTabChange?.(tab.value)}
                        >
                            {tab.label}
                        </button>
                    );
                })}
            </div>
            {!standalone && <div>{tabContent}</div>}
        </div>
    );
}
